<!--
 * @Author: xiaokun
 * @Date: 2020-04-10 16:49:50
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-06-04 11:59:08
 * @Description: 问题列
 -->
<template>
  <div class="list-table-question cursor ellipsis">
    <mk-popover
      :width="500"
      placement="top-start"
      trigger="hover"
      popper-class="mba-question-bank-popover mba-question-bank-popover-another"
    >
      <div>
        <div class="pop-title">
          问题详情
        </div>
        <div class="answer">
          <div class="item">
            <span class="item-left">问题：</span>
            <span>{{ scope.row.title }}</span>
          </div>
          <div class="item item-answer">
            <span class="item-left">答案：</span>
            <pre v-html="scope.row.answer" />
            <!-- <span>{{ scope.row.answer }}</span> -->
          </div>
        </div>
      </div>
      <div
        slot="reference"
        class="question-name cursor ellipsis"
      >
        {{ scope.row.title }}
      </div>
    </mk-popover>
  </div>
</template>

<script>
export default {
  name: 'ListTableNotApprovalNum',
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.list-table-question {
  .question-name {
    font-size: 13px;
    color: #009cff;

    @extend .ellipsis;
    // overflow: hidden;
    // white-space: nowrap;
    // text-overflow: ellipsis；;
  }
}
</style>

<style lang="scss">
.mba-question-bank-popover {
  padding: 0;
  width: 256px;

  pre {
    margin: 0;
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: inherit;
  }

  .pop-title {
    padding: 0 16px;
    height: 30px;
    line-height: 30px;
    color: #262626;
    border-bottom: 1px solid rgba(0, 0, 0, 0.09);
  }

  .pop-input {
    margin-top: 11px;
    padding: 0 16px;
  }

  .pop-button {
    padding: 15px 16px 25px;
    text-align: right;
  }
}

.mba-question-bank-popover-another {
  width: 320px;

  .answer {
    font-size: 13px;
    padding: 8px 16px 24px;
    max-height: 450px;
    overflow: scroll;

    .item {
      display: flex;
      color: #595959;
      line-height: 18px;

      .item-left {
        flex-shrink: 0;
      }
    }

    .item-answer {
      margin-top: 11px;
    }
  }
}
</style>
